import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer";
import SBEditable from "../../../components/sbEditable/sbEditable";
import styles from "./richTextSummaryDetail.module.scss";

function RichTextSummaryDetail({ blok }) {
  return (
    <SBEditable blok={blok} key={blok._uid} withClass={styles.root}>
      <details>
        <summary className={blok.summary_text_color}>{blok.summary}</summary>
        <RichTextWithBlokRenderer document={blok.description} />
      </details>
    </SBEditable>
  );
}

export default RichTextSummaryDetail;
